import React from "react";
import Layout from "./Layout";

const Dashboard = () => {
  return (
    <div>
      <Layout>Dashobard</Layout>
    </div>
  );
};

export default Dashboard;
